import React, { useState, useEffect } from 'react';
import { Spinner, Alert } from 'react-bootstrap';
import { API_URL } from '../../../config';
import { useAppData } from '../AppDataContext';
import { useLocation } from 'react-router-dom';
import { useResponsiveStyles } from './useResponsiveStyles';


const BlogPostExcerpt = ({ styles = {} }) => {

  const appliedStyles = useResponsiveStyles(styles);


  const { subdomain } = useAppData();
  const location = useLocation();
  const urlSegments = location.pathname.split('/');
  const effectivePostId = urlSegments[urlSegments.length - 1];

  const [excerpt, setExcerpt] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log("Effective postId:", effectivePostId);
  }, [effectivePostId]);

  useEffect(() => {
    if (!effectivePostId || !subdomain) return;
    setLoading(true);
    fetch(`${API_URL}/blog-post?account_key=${subdomain}&post_id=${effectivePostId}&field=excerpt`)
      .then((res) => {
        if (!res.ok) {
          throw new Error('Failed to fetch blog post data.');
        }
        return res.json();
      })
      .then((data) => {
        // Extract the excerpt from data.data.excerpt based on the API response structure.
        setExcerpt(data.data.excerpt);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [effectivePostId, subdomain]);

  if (loading) return <Spinner animation="border" size="sm" />;
  if (error) return <Alert variant="danger">{error}</Alert>;

  return <div style={appliedStyles.container}><p style={appliedStyles.text}>{excerpt}</p></div>;
};

export default BlogPostExcerpt;
